import * as yup from 'yup';

export const signalSchema = yup.object().shape({
  currentPair: yup.string().required('Currency is required'),

  riskLevel: yup.string().required('Risk level is required'),

  value: yup
    .string()
    .required('Entry value is required')
    .max(20, 'Value must not exceed 20 characters')
    .matches(/^[0-9]+(\.[0-9]+)?$/, 'Entry value must be a valid number'),

  targetLevel1: yup
    .string()
    .required('TP1 value is required')
    .max(20, 'Value must not exceed 20 characters')
    .matches(/^[0-9]+(\.[0-9]+)?$/, 'TP1 must be a valid number'),

  targetLevel2: yup
    .string()
    .required('TP2 value is required')
    .max(20, 'Value must not exceed 20 characters')
    .matches(/^[0-9]+(\.[0-9]+)?$/, 'TP2 must be a valid number'),

  targetLevel3: yup
    .string()
    .required('TP3 value is required')
    .max(20, 'Value must not exceed 20 characters')
    .matches(/^[0-9]+(\.[0-9]+)?$/, 'TP3 must be a valid number'),

  stopLoss: yup
    .string()
    .required('Stop Loss value is required')
    .max(20, 'Value must not exceed 20 characters')
    .matches(/^[0-9]+(\.[0-9]+)?$/, 'Stop Loss must be a valid number'),

  orderType: yup.string().required('Order Type is required'),
});

export const validateForm = async (formData) => {
  try {
    await signalSchema.validate(formData, { abortEarly: false });
    return {}; // No errors
  } catch (err) {
    const errors = {};
    err.inner.forEach((error) => {
      errors[error.path] = error.message;
    });
    return errors;
  }
};
